const ru = {
  // Common
  "common.loading": "Загрузка...",
  "common.error": "Произошла ошибка",
  "common.save": "Сохранить",
  "common.cancel": "Отмена",
  "common.delete": "Удалить",
  "common.edit": "Редактировать",
  "common.back": "Назад",
  "common.logout": "Выйти",
  "common.submit": "Отправить",
  "common.search": "Поиск",
  "common.noData": "Данные не найдены",
  "common.retry": "Попробовать снова",
  "common.close": "Закрыть",
  "common.more": "Ещё",
  "common.open_app": "Открыть приложение",

  // Auth
  "auth.login": "Войти",
  "auth.register": "Регистрация",
  "auth.logout": "Выйти",
  "auth.email": "Email",
  "auth.password": "Пароль",
  "auth.confirm_password": "Подтвердите пароль",
  "auth.username": "Имя пользователя",
  "auth.display_name": "Полное имя",
  "auth.forgot_password": "Забыли пароль?",
  "auth.no_account": "Нет аккаунта?",
  "auth.has_account": "Уже есть аккаунт?",
  "auth.google_login": "Войти через Google",
  "auth.login_success": "Вход выполнен успешно",
  "auth.register_success": "Регистрация выполнена успешно",
  "auth.logout_success": "Вы вышли из системы",
  "auth.verify_email": "Подтверждение email",
  "auth.otp_sent": "Код подтверждения отправлен на ваш email",
  "auth.enter_otp": "Введите 6-значный код",
  "auth.resend_otp": "Отправить код снова",
  "auth.otp_verified": "Email подтверждён!",

  // Navigation
  "nav.feed": "Лента",
  "nav.lifemap": "Моя жизнь",
  "nav.ai": "AI",
  "nav.calendar": "Календарь",
  "nav.new_post": "Новый",
  "nav.video": "Видеодневник",
  "nav.challenges": "Челленджи",
  "nav.highlights": "Избранное",
  "nav.journal": "Дневник",
  "nav.analytics": "Аналитика",
  "nav.search": "Поиск",
  "nav.notifications": "Уведомления",
  "nav.settings": "Настройки",
  "nav.galaxy": "Жизнь в звёздах",
  "nav.profile": "Профиль",
  "nav.other": "Другое",

  // Feed
  "feed.title": "Лента",
  "feed.no_posts": "Постов пока нет",
  "feed.load_more": "Загрузить ещё",
  "feed.create_first": "Напишите свой первый пост",

  // Post
  "post.create": "Создать пост",
  "post.title": "Заголовок (необязательно)",
  "post.body": "Что произошло сегодня? Напишите свои мысли...",
  "post.date": "Дата",
  "post.mood": "Настроение",
  "post.privacy": "Кто видит",
  "post.tags": "Теги",
  "post.location": "Местоположение",
  "post.media": "Добавить фото/видео",
  "post.add_tag": "Добавить тег",
  "post.save": "Сохранить",
  "post.delete": "Удалить пост",
  "post.delete_confirm": "Вы уверены, что хотите удалить пост?",
  "post.saved": "Запись сохранена! ✨",
  "post.deleted": "Пост удалён",
  "post.view_day": "Просмотр дня",
  "post.comments": "Комментарии",
  "post.no_comments": "Комментариев пока нет. Будьте первым! 💬",
  "post.add_comment": "Написать комментарий...",
  "post.comment_added": "Комментарий добавлен",
  "post.reaction_failed": "Не удалось добавить реакцию",

  // Privacy options
  "privacy.public": "Все",
  "privacy.friends": "Друзья",
  "privacy.private": "Только я",

  // Mood options
  "mood.great": "Отлично",
  "mood.good": "Хорошо",
  "mood.neutral": "Нейтрально",
  "mood.bad": "Плохо",
  "mood.terrible": "Ужасно",

  // Calendar
  "calendar.title": "Календарь жизни",
  "calendar.year": "Год",
  "calendar.today": "Сегодня",
  "calendar.this_day": "Воспоминания этого дня",
  "calendar.no_entries": "Записей за этот день нет",
  "calendar.view_day": "Просмотр дня",
  "calendar.days_active": "Активных дней",
  "calendar.total_posts": "Всего постов",

  // Analytics
  "analytics.title": "Аналитика жизни",
  "analytics.period.week": "Неделя",
  "analytics.period.month": "Месяц",
  "analytics.period.year": "Год",
  "analytics.mood_trends": "Динамика настроения",
  "analytics.activity": "Активность",
  "analytics.growth": "Рост",

  // Profile
  "profile.title": "Профиль",
  "profile.edit": "Редактировать профиль",
  "profile.posts": "Посты",
  "profile.friends": "Друзья",
  "profile.add_friend": "Добавить в друзья",
  "profile.request_sent": "Запрос отправлен",
  "profile.bio": "О себе",
  "profile.location": "Местоположение",
  "profile.website": "Сайт",
  "profile.joined": "Присоединился",

  // Settings
  "settings.title": "Настройки",
  "settings.profile": "Профиль",
  "settings.security": "Безопасность",
  "settings.notifications": "Уведомления",
  "settings.language": "Язык",
  "settings.language.select": "Выберите язык",
  "settings.language.uz": "Узбекский",
  "settings.language.ru": "Русский",
  "settings.language.en": "Английский",
  "settings.save_profile": "Сохранить профиль",
  "settings.change_password": "Сменить пароль",
  "settings.current_password": "Текущий пароль",
  "settings.new_password": "Новый пароль",
  "settings.delete_account": "Удалить аккаунт",
  "settings.profile_saved": "Профиль сохранён",
  "settings.password_changed": "Пароль изменён",

  // Search
  "search.title": "Поиск",
  "search.placeholder": "Поиск пользователей...",
  "search.no_results": "Результатов не найдено",

  // Notifications
  "notifications.title": "Уведомления",
  "notifications.empty": "Уведомлений нет",
  "notifications.mark_all_read": "Отметить все как прочитанные",

  // Video
  "video.title": "Видеодневник",
  "video.upload": "Загрузить видео",
  "video.no_videos": "Видео пока нет",
  "video.uploading": "Загружается...",

  // Challenges
  "challenges.title": "Челленджи",
  "challenges.join": "Участвовать",
  "challenges.active": "Активные",
  "challenges.completed": "Завершённые",

  // Highlights
  "highlights.title": "Избранное",
  "highlights.create": "Создать избранное",
  "highlights.empty": "Избранного пока нет",

  // Journal
  "journal.title": "Дневник",
  "journal.new_entry": "Новая запись",
  "journal.no_entries": "Записей пока нет",

  // Errors
  "error.network": "Ошибка сети. Проверьте интернет.",
  "error.unauthorized": "Необходима авторизация",
  "error.not_found": "Страница не найдена",
  "error.server": "Ошибка сервера. Попробуйте позже.",
  "error.login_failed": "Неверный логин или пароль",
  "error.register_failed": "Ошибка регистрации",

  // Days of week
  "day.mon": "Пн",
  "day.tue": "Вт",
  "day.wed": "Ср",
  "day.thu": "Чт",
  "day.fri": "Пт",
  "day.sat": "Сб",
  "day.sun": "Вс",

  // Months
  "month.1": "Январь",
  "month.2": "Февраль",
  "month.3": "Март",
  "month.4": "Апрель",
  "month.5": "Май",
  "month.6": "Июнь",
  "month.7": "Июль",
  "month.8": "Август",
  "month.9": "Сентябрь",
  "month.10": "Октябрь",
  "month.11": "Ноябрь",
  "month.12": "Декабрь",
};

export default ru;
